import { SPECIAL_UI_ACCESS_ORGANIZATION_ID } from "../../../organizations.js";

export const commandType = "SCHEDULE_WAIT_FOR_PERIOD";
export const label = "Wait for period";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [SPECIAL_UI_ACCESS_ORGANIZATION_ID];
